import React, { useEffect, useState } from "react";
import PersonalDetails from "./profileDetails"; // Existing component
import Gallery from "./Gallery";
import Defaultlocation from "./Defaultlocation";
import { useParams, useNavigate } from "react-router-dom";
import { oneKlicks } from "../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { getuserdata } from "../../services/apiService";
import Preloader from "../../Uitiles/Preloader";

const UserProfileDetails = () => {
    const [userdata, setUserdata] = useState({});
    const [userid, setUserId] = useState("");
    const { sublink } = useParams();
    const navigate = useNavigate();
    const [tabsest, setTabseset] = useState("Personal Details");
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const [galleryImages, setGalleryImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [newVideoUrl, setNewVideoUrl] = useState("");
    const [galleryid, setGalleryid] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState('india');
    const [searchAddress, setSearchAddress] = useState('');
    const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 });

    const [personalDetailsFormData, setPersonalDetailsFormData] = useState({
        name: "",
        gendar: "",
        subheading: "",
        first_name: "",
        last_name: "",
        display_name: "",
        starting_price: "",
        mobile_number: "",
        phone: "",
        description: "",
        languages: [],
        profile_photo: null,
        profile_photo_url: null,
        profile_banner: null,
        profile_banner_url: null,
        memberships: [],
        email: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postal_code: ""
    });

    const [profilePhotoPreview, setProfilePhotoPreview] = useState(null);
    const [profilePhotoUploading, setProfilePhotoUploading] = useState(false);

    // Tab to URL mapping
    const tabToUrlMapping = {
        "Personal Details": "personal-details",
        "Gallery": "gallery",
        "Default location": "default-location"
    };

    useEffect(() => {
        if (sublink) {
            const tabMapping = {
                "gallery": "Gallery",
                "default-location": "Default location",
                "personal-details": "Personal Details"
            };
            setTabseset(tabMapping[sublink] || "Personal Details");
        }
    }, [sublink]);

    const handleTabClick = (tabName) => {
        setTabseset(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/user-profile?tab=${urlPath}`);
        }
    };

    useEffect(() => {
        const loadInitialData = async () => {
            setIsLoading(true);
            try {
                await getalluserdata();
                await getallgallery();
                await getalldefaultlocation();
            } catch (error) {
                console.error("Error loading initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        loadInitialData();
    }, []);

    const getalluserdata = async () => {
        try {
            const user_id = await getuserdata("id");
            const getcruserdata = await oneKlicks.read("", "users", { id: user_id }, "", "", "", "");

            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                const userData = getcruserdata.data[0];
                setUserdata(userData);
                setUserId(userData.id);

                let languages = userData.languages;
                if (typeof languages === 'string') {
                    try { languages = JSON.parse(languages); } catch (e) { languages = []; }
                }

                let memberships = userData.memberships;
                if (typeof memberships === 'string') {
                    try { memberships = JSON.parse(memberships); } catch (e) { memberships = []; }
                }

                setPersonalDetailsFormData({
                    name: userData.name || "",
                    email: userData.email || "",
                    gendar: userData.gendar || "",
                    subheading: userData.subheading || "",
                    first_name: userData.first_name || "",
                    last_name: userData.last_name || "",
                    display_name: userData.display_name || "",
                    starting_price: userData.starting_price || "",
                    mobile_number: userData.mobile_number || userData.phone || "",
                    phone: userData.phone || "",
                    description: userData.description || "",
                    languages: languages || [],
                    profile_photo: userData.profile_photo || null,
                    profile_photo_url: userData.profile_photo_url || null,
                    profile_banner: userData.profile_banner || null,
                    profile_banner_url: userData.profile_banner_url || null,
                    memberships: memberships || [],
                    address: userData.address || "",
                    city: userData.city || "",
                    state: userData.state || "",
                    country: userData.country || "",
                    postal_code: userData.postal_code || ""
                });

                if (userData.profile_photo_url) {
                    const photoUrl = userData.profile_photo_url;
                    const previewUrl = photoUrl.startsWith('http') || photoUrl.startsWith('data:')
                        ? photoUrl
                        : (process.env.REACT_APP_API_BASE_URL + (photoUrl.startsWith('/') ? photoUrl : '/' + photoUrl));
                    setProfilePhotoPreview(previewUrl);
                }
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            toast.error('Failed to fetch user data');
        }
    };

    const getallgallery = async () => {
        try {
            const user_id = await getuserdata("id");
            const getcruserdata = await oneKlicks.read("", "staff_gallery", { user_id }, "", "", "", "");
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setGalleryImages(getcruserdata.data[0].images);
                setVideos(getcruserdata.data[0].videos);
                setGalleryid(getcruserdata.data[0].id);
            }
        } catch (error) {
            console.error("Error fetching gallery:", error);
        }
    };

    const getalldefaultlocation = async () => {
        try {
            const user_id = await getuserdata("id");
            const getcruserdata = await oneKlicks.read("", "staff_default_location", { user_id }, "", "", "", "");
            if (getcruserdata.success === true && getcruserdata.data.length > 0) {
                setSelectedCountry(getcruserdata.data[0].country);
                setSearchAddress(getcruserdata.data[0].address);
                setMapCenter({ lat: getcruserdata.data[0].lat, lng: getcruserdata.data[0].lng });
            }
        } catch (error) {
            console.error("Error fetching default location:", error);
        }
    };

    const handlePersonalDetailsInputChange = (e) => {
        const { name, value } = e.target;
        setPersonalDetailsFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleProfilePhotoSelect = async (file) => {
        setProfilePhotoUploading(true);
        try {
            const root = "users/profile";
            const status = "public";
            const uploadedFile = await OneKlicksFileSDK.uploadFile(root, status, file);

            if (uploadedFile.success) {
                const relativeUrl = (uploadedFile.file && uploadedFile.file.root && uploadedFile.file.fileName)
                    ? (uploadedFile.file.root + '/' + uploadedFile.file.fileName)
                    : uploadedFile.fileUrl;

                setPersonalDetailsFormData(prev => ({
                    ...prev,
                    profile_photo: uploadedFile.fileId || uploadedFile.id,
                    profile_photo_url: relativeUrl
                }));

                const photoUrl = uploadedFile.fileUrl;
                const previewUrl = photoUrl.startsWith('http') || photoUrl.startsWith('data:')
                    ? photoUrl
                    : (process.env.REACT_APP_API_BASE_URL + (photoUrl.startsWith('/') ? photoUrl : '/' + photoUrl));

                setProfilePhotoPreview(previewUrl);
                toast.success("Photo uploaded successfully");
            } else {
                toast.error("Failed to upload photo");
            }
        } catch (error) {
            console.error("Error uploading photo:", error);
            toast.error("Error uploading photo");
        } finally {
            setProfilePhotoUploading(false);
        }
    };

    const handleProfilePhotoRemove = () => {
        setPersonalDetailsFormData(prev => ({
            ...prev,
            profile_photo: null,
            profile_photo_url: null
        }));
        setProfilePhotoPreview(null);
    };

    const handlePersonalDetailsSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const user_id = await getuserdata("id");
            const updatePayload = {
                ...personalDetailsFormData,
                languages: JSON.stringify(personalDetailsFormData.languages),
                memberships: JSON.stringify(personalDetailsFormData.memberships)
            };

            const updateResult = await oneKlicks.update("", "users", updatePayload, { id: user_id });
            if (updateResult.success) {
                toast.success("Profile updated successfully");
                await getalluserdata();
            } else {
                toast.error("Failed to update profile");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("An error occurred while updating profile");
        } finally {
            setIsSaving(false);
        }
    };

    const handleGallerySubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const user_id = await getuserdata("id");
            const galleryPayload = {
                user_id,
                images: JSON.stringify(galleryImages),
                videos: JSON.stringify(videos)
            };
            const updateResult = await oneKlicks.update("", "staff_gallery", galleryPayload, { user_id });
            if (updateResult.success) {
                toast.success("Gallery updated successfully");
            } else {
                // If update fails, maybe try create?
                const createResult = await oneKlicks.create("", "staff_gallery", galleryPayload);
                if (createResult.success) {
                    toast.success("Gallery saved successfully");
                } else {
                    toast.error("Failed to save gallery");
                }
            }
        } catch (error) {
            console.error("Error saving gallery:", error);
            toast.error("An error occurred while saving gallery");
        } finally {
            setIsSaving(false);
        }
    };

    const handleDefaultLocationSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const user_id = await getuserdata("id");
            const locationPayload = {
                user_id,
                country: selectedCountry,
                address: searchAddress,
                lat: mapCenter.lat,
                lng: mapCenter.lng
            };
            const updateResult = await oneKlicks.update("", "staff_default_location", locationPayload, { user_id });
            if (updateResult.success) {
                toast.success("Location updated successfully");
            } else {
                const createResult = await oneKlicks.create("", "staff_default_location", locationPayload);
                if (createResult.success) {
                    toast.success("Location saved successfully");
                } else {
                    toast.error("Failed to save location");
                }
            }
        } catch (error) {
            console.error("Error saving location:", error);
            toast.error("An error occurred while saving location");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
            {isLoading ? (
                <Preloader />
            ) : (
                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9">
                            <div className="dc-dashboardbox dc-dashboardtabsholder">
                                <div className="dc-dashboardboxtitle">
                                    <h2>{tabsest}</h2>
                                </div>
                                <div className="dc-dashboardtabs">
                                    <ul className="dc-tabstitle nav navbar-nav">
                                        <li className="nav-item">
                                            <a className={tabsest === "Personal Details" ? "active" : ""}
                                                href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Personal Details"); }}>
                                                Personal Details
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={tabsest === "Gallery" ? "active" : ""}
                                                href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Gallery"); }}>
                                                Gallery
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={tabsest === "Default location" ? "active" : ""}
                                                href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Default location"); }}>
                                                Default location
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                {tabsest === "Personal Details" && (
                                    <form className="dc-user-profile" onSubmit={handlePersonalDetailsSubmit}>
                                        <PersonalDetails
                                            formValues={personalDetailsFormData}
                                            handleInputChange={handlePersonalDetailsInputChange}
                                            saving={isSaving}
                                            loading={false}
                                            onProfilePhotoSelect={handleProfilePhotoSelect}
                                            onProfilePhotoRemove={handleProfilePhotoRemove}
                                            profilePhotoUploading={profilePhotoUploading}
                                            profilePhotoPreview={profilePhotoPreview}
                                        />
                                        <div className="dc-btnarea">
                                            <button type="submit" className="dc-btn" disabled={isSaving}>
                                                {isSaving ? "Saving..." : "Save Changes"}
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {tabsest === "Gallery" && (
                                    <form className="dc-user-profile" onSubmit={handleGallerySubmit}>
                                        <Gallery
                                            galleryImages={galleryImages}
                                            setGalleryImages={setGalleryImages}
                                            videos={videos}
                                            setVideos={setVideos}
                                            newVideoUrl={newVideoUrl}
                                            setNewVideoUrl={setNewVideoUrl}
                                            isUploading={profilePhotoUploading}
                                            setIsUploading={setProfilePhotoUploading}
                                        />
                                        <div className="dc-btnarea">
                                            <button type="submit" className="dc-btn" disabled={isSaving}>
                                                {isSaving ? "Saving..." : "Save Gallery"}
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {tabsest === "Default location" && (
                                    <form className="dc-user-profile" onSubmit={handleDefaultLocationSubmit}>
                                        <Defaultlocation
                                            selectedCountry={selectedCountry}
                                            setSelectedCountry={setSelectedCountry}
                                            searchAddress={searchAddress}
                                            setSearchAddress={setSearchAddress}
                                            mapCenter={mapCenter}
                                            setMapCenter={setMapCenter}
                                            userdata={userdata}
                                        />
                                        <div className="dc-btnarea">
                                            <button type="submit" className="dc-btn" disabled={isSaving}>
                                                {isSaving ? "Saving..." : "Save Location"}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
};

export default UserProfileDetails;
